"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgCalculatorFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M24 2H8a3 3 0 00-3 3v22a3 3 0 003 3h16a3 3 0 003-3V5a3 3 0 00-3-3zM12 25h-2v-2h2zm0-5h-2v-2h2zm0-5h-2v-2h2zm5 10h-2v-2h2zm0-5h-2v-2h2zm0-5h-2v-2h2zm5 10h-2v-2h2zm0-5h-2v-2h2zm0-5h-2v-2h2zm0-5H10V7h12z" })));
}
exports.default = SvgCalculatorFilled;
//# sourceMappingURL=CalculatorFilled.js.map